<template>
	<div v-if="model" class="overlay-link">
		<a ref="targetLink" href="#" 
		v-bind:class="[ 'overlay-toggle', { video: model.src, image: image, 'has-icon': model.link_text }]"  
		v-global-overlay="{ model: model, requestPath: requestPath, dark: dark, index: index }">
			<span class="label" v-if="linkText" v-html="linkText"></span>
			<img v-if="image" v-bind:src="image.src" v-bind:alt="image.alt" />
			<span v-if="hasIcon!==false && !image" ref="targetIcon" class="plus-or-close"></span>
		</a>
	</div>
</template>

<style lang="scss">
  //@import "../../styles/scss/global/overlay";
  //@import "../../styles/scss/component/overlay/link";
</style>

<script>
export default {
	props: ['requestPath', 'image', 'model', 'index', 'dark', 'linkText', 'hasIcon']
}
</script>